import { Link } from 'react-router-dom';
import { Modal, Illustration } from './ui.jsx';
import Icon from './Icon.jsx';
import { firstName } from '../lib/format.js';

/**
 * Shown when someone taps "Book now" on a nurse who has no bookable window.
 *
 * Two different situations reach here and they need different wording: a nurse
 * who has never published a calendar, and one who is verified but has switched
 * themselves off. Neither is the patient's fault, so the dialog leads with what
 * they can do next rather than with the refusal.
 */
export default function NoAvailabilityDialog({ nurse, onClose }) {
  const name = firstName(nurse.name);
  const offDuty = nurse.is_available === 0 || nurse.is_available === false;

  return (
    <Modal
      title={offDuty ? 'Not accepting bookings' : 'No open time slots'}
      onClose={onClose}
      size={460}
      footer={
        <>
          <button className="btn btn-ghost" onClick={onClose}>
            Close
          </button>
          <Link to="/search" className="btn btn-primary" onClick={onClose}>
            <Icon name="search" /> Find another nurse
          </Link>
        </>
      }
    >
      <div className="center">
        <Illustration name="schedule" width={170} />
        <p className="muted mt-2">
          {offDuty ? (
            <>
              <strong>{name}</strong> has paused new bookings, so their calendar is closed for now. Existing
              visits are unaffected.
            </>
          ) : (
            <>
              <strong>{name}</strong> hasn’t published any available time slots yet, so there is nothing to
              book. Nurses open their calendar themselves.
            </>
          )}
        </p>
        <div className="banner banner-neutral mt-3" style={{ textAlign: 'left', marginBottom: 0 }}>
          <Icon name="info" />
          <span className="grow tiny">
            You can still view {name}’s profile, and check back later — the Book button turns on the moment
            they publish a slot.
          </span>
        </div>
      </div>
    </Modal>
  );
}
